let appInstance: any = null

export function setAppInstance(app: any) {
    appInstance = app
}

export function getAppInstance() {
    return appInstance
}